exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-slider-wrapper[data-v-f2286098]{width:100%;max-width:800px;padding-bottom:10px;margin:auto}.v-carousel__controls[data-v-f2286098]{display:none!important}.embed-slider-wrapper .v-window-item[data-v-f2286098]{padding-left:0;padding-right:0}", ""]);

// exports
